import { render, staticRenderFns } from "./HoeyInfoMobile.vue?vue&type=template&id=060e1b03&scoped=true"
import script from "./HoeyInfoMobile.vue?vue&type=script&lang=js"
export * from "./HoeyInfoMobile.vue?vue&type=script&lang=js"
import style0 from "./HoeyInfoMobile.vue?vue&type=style&index=0&id=060e1b03&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060e1b03",
  null
  
)

export default component.exports